import { BaseQueryApi, createApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from 'store';
import { userSelector } from 'store/slices/user-slice';

// import { API_ROUTES } from 'constants/api-routes';
// import { RootState } from 'store';
// import configSelector from 'store/config/config.selectors';
// import { removeCredentials, setUser, userSelector } from 'store/slices/user-slice';
// import { STATUS_CODES } from 'types/general.types';

// const prepareHeaders = (
//   headers: Headers,
//   api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>,
// ) => {
//   const state = api.getState() as RootState;

//   if (state.user.user?.accessToken) {
//     headers.set('Authorization', `Bearer ${userSelector(state).user?.accessToken}`);
//   }
//   headers.set('DUCKENERGY-API-VERSION', configSelector.getApiVersion(state).toString());

//   return headers;
// };

// const executeBaseQuery = (baseUrl: string) =>
//   fetchBaseQuery({
//     baseUrl,
//     prepareHeaders,
//   });

// let refreshPromise: Promise<void> | null = null;

// const refreshToken = async (api: BaseQueryApi): Promise<void> => {
//   const state = api.getState() as RootState;
//   const baseApiUrl = configSelector.apiBaseUrl(state);

//   const { refreshToken: token, tenantKey } = state.user.user ?? {};
//   if (!token || !tenantKey) throw new Error('Missing refreshToken or tenant key');

//   const response = await fetch(`${baseApiUrl}${API_ROUTES.REFRESH_TOKEN}/${tenantKey}`, {
//     method: 'POST',
//     headers: {
//       'DUCKENERGY-API-VERSION': configSelector.getApiVersion(state).toString(),
//     },
//     body: token,
//   });

//   if (response.ok) {
//     api.dispatch(setUser());
//   } else {
//     throw new Error('Failed to get new access token');
//   }
// };

// const ensureFreshToken = async (api: BaseQueryApi): Promise<void> => {
//   if (!refreshPromise) {
//     refreshPromise = refreshToken(api)
//       .catch(error => {
//         console.error('Reauthentication failed:', error);
//       })
//       .finally(() => {
//         refreshPromise = null;
//       });
//   }

//   return refreshPromise;
// };

// const handle401WithRefresh = async (
//   args: string | FetchArgs,
//   api: BaseQueryApi,
//   extraOptions: Record<string, never>,
//   baseQueryFn: ReturnType<typeof executeBaseQuery>,
// ) => {
//   let result = await baseQueryFn(args, api, extraOptions);

//   if (result.error?.status === STATUS_CODES.UNATHORIZED) {
//     await ensureFreshToken(api);
//     result = await baseQueryFn(args, api, extraOptions);
//     if (result.error) {
//       api.dispatch(removeCredentials());
//     }
//   }

//   return result;
// };

// const baseQueryWithReauth = async (
//   args: string | FetchArgs,
//   api: BaseQueryApi,
//   extraOptions: Record<string, never>,
// ) => {
//   const state = api.getState() as RootState;
//   const baseApiUrl = configSelector.apiBaseUrl(state);

//   const baseQueryFn = executeBaseQuery(baseApiUrl);
//   return handle401WithRefresh(args, api, extraOptions, baseQueryFn);
// };

// export const baseApi = createApi({
//   reducerPath: 'baseApi',
//   tagTypes: ['Account'],
//   baseQuery: baseQueryWithReauth,
//   endpoints: () => ({}),
// });

// import { RootState } from 'store';
// import configSelector from 'store/config/config.selectors';
// import { userSelector } from 'store/slices/user-slice';

const prepareHeaders = (
  headers: Headers,
  api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>,
) => {
  const state = api.getState() as RootState;
  const idToken = userSelector(state).user?.idToken?.__raw;

  if (idToken) {
    headers.set('Authorization', `Bearer ${idToken}`);
  }

  return headers;
};

const rawBaseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders,
  });

const baseQuery = (args: string | FetchArgs, api: BaseQueryApi, extraOptions: Record<string, never>) => {
  const baseApiUrl = process.env.REACT_APP_BASE_API_URL!;
  const base = rawBaseQuery(baseApiUrl);

  let finalArgs: FetchArgs;
  if (typeof args === 'string') {
    finalArgs = { url: args };
  } else {
    finalArgs = { ...args };
    if (args.responseHandler) {
      finalArgs.responseHandler = args.responseHandler;
    }
  }

  return base(finalArgs, api, extraOptions);
};

export const baseApi = createApi({
  reducerPath: 'baseApi',
  tagTypes: ['Account'],
  baseQuery,
  endpoints: () => ({}),
});
